import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "ee8c4173-2596-4ae9-b669-6bf550fccf5f",
  publicId: "3",
  name: "Mechanics: Damped harmonic oscillator",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },

  body: [principle01, task01, task02, task03],
};

export default lesson;
